function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var WithdrawalTemplate = require('./withdrawal.template');
var WithdrawalOverlay = /*#__PURE__*/function () {
  function WithdrawalOverlay(app, mod) {
    _classCallCheck(this, WithdrawalOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
  }
  return _createClass(WithdrawalOverlay, [{
    key: "render",
    value: function render() {
      var _root$querySelector,
        _this = this;
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$ticker = _ref.ticker,
        ticker = _ref$ticker === void 0 ? '' : _ref$ticker,
        _ref$available = _ref.available,
        available = _ref$available === void 0 ? '0' : _ref$available;
      this.overlay.show(WithdrawalTemplate({
        ticker: ticker,
        available: available
      }));
      var root = document.querySelector('.store-withdrawal');
      root === null || root === void 0 || (_root$querySelector = root.querySelector('[data-action="cancel"]')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function (e) {
        e.preventDefault();
        _this.overlay.close();
      });
      root === null || root === void 0 || root.addEventListener('submit', function (e) {
        e.preventDefault();
      });
    }
  }]);
}();
module.exports = WithdrawalOverlay;